<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" class="p-button-danger" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-4xl">Principale titolo di studio</label>
</div>
<div class="flex align-items-start flex-column
            lg:flex-row lg:justify-content-between bg-dashboard bg-shadow
             p-5 border-radius-right-dashboard col-8 colorTm
            sm:flex-row col-11">
  <div class="flex align-items-start flex-column md:flex-row w-full ">
    <div class="col-2">
      <p-avatar image="assets/img/awesome-graduation-cap.svg" shape="circle" size="xlarge">
      </p-avatar>
    </div>
    <div class="col-10 col-sm-10 flex flex-wrap" *ngIf="studyList.length > 0 || lastStudy.IdAnagraficaUtenteIstruzione > 0">
      <div class="w-full overflow-hidden">
        <label class="w-full text-2xl">{{lastStudy.DescrizioneLivelloIstruzione1}} presso <label
          class="font-bold"> {{lastStudy.TitoloStudio}}</label></label>
      </div>
      <div class="w-full mt-5 flex">
        <label class="font-bold">Voto: </label>
        <label class="ml-2"> {{lastStudy.VotoConseguimento}}</label>
        <label *ngIf="lastStudy.InCorso" class="font-bold ml-2"> (In Corso)</label>
        <label *ngIf="!lastStudy.InCorso" class="font-bold ml-2"> conseguito il {{lastStudy.AnnoConseguimento}}</label>
      </div>
    </div>

    <div class="col-10 flex flex-wrap" *ngIf="studyList.length == 0 && lastStudy.IdAnagraficaUtenteIstruzione == 0">

      <div class="w-full">
        <label class="w-full text-2xl">Nessun Titolo Inserito</label>
      </div>

    </div>

  </div>
</div>


<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-2xl">Formazione</label>

  <div class="w-full mt-5">
    <ul class="list-none p-0 m-0 w-full">
      <li
        class="flex w-full align-content-center mb-3"
        *ngFor="let study of studyList; index as i">
        <div class="col-10 lg:col-11 flex flex-column md:flex-row align-items-center md:justify-content-between p-0 border-1 sharedListTemplate ">
          <div class="col-1 flex">
            <p-avatar image="assets/img/awesome-graduation-cap.svg" shape="circle" class="flex"></p-avatar>
          </div>
          <div class="col-12 lg:col-2 flex align-content-center flex-wrap text-centered">
            <label class="w-full lg:flex font-bold sm:align-content-center text-align-center">{{study.DescrizioneLivelloIstruzione1}}</label>
          </div>
          <div class="col-12 lg:col-2 flex align-content-center flex-wrap text-centered">
            <label class="w-full lg:flex font-bold sm:align-content-center text-align-center">{{study.DescrizioneLivelloIstruzione2}}</label>
          </div>
          <div class="col-12 lg:col-2 flex align-content-center flex-wrap text-centered">
            <label class="w-full lg:flex font-bold sm:align-content-center text-align-center">{{study.DescrizioneLivelloIstruzione3}}</label>
          </div>

          <div class="col-12 lg:col-2 flex align-content-center flex-wrap text-centered">
            <label *ngIf="study.VotoConseguimento != '/' " class="font-bold text-center sm:align-content-center">{{study.VotoConseguimento}}</label>
          </div>
          <div class="col-12 lg:col-1 flex align-content-center justify-content-center">
            <label *ngIf="!study.InCorso" class="flex align-content-center text-center">{{study.AnnoConseguimento}}</label>
            <label *ngIf="study.InCorso" class="font-bold ml-2 text-center sm:align-content-center"> (In Corso)</label>
          </div>
        </div>
        <div class="col-2 lg:col-1 flex align-content-center flex-wrap">
          <div class="col-12 flex align-content-center">
            <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-outlined p-button-danger" (click)="studyDelete(study.IdAnagraficaUtenteIstruzione)"></button>
          </div>
        </div>
      </li>
    </ul>
    <button pButton pRipple label="Aggiungi formazione"
            class="mt-4 col-11 p-button-rounded p-3 btnAddWork font-bold"
            icon="pi pi-plus" iconPos="left"
            (click)="addStudy()"></button>
  </div>
</div>

<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-2xl">Attestati / Certificazioni</label>

  <div class="w-full mt-5">
    <ul class="list-none p-0 m-0 w-full">
      <li
        class="flex w-full align-content-center mb-3"
        *ngFor="let attested of profileAttesteds; index as i">
        <div class="col-10 lg:col-11 flex flex-column md:flex-row align-items-center md:justify-content-between p-0 border-1 sharedListTemplate">
          <div class="col-1 flex">
            <p-avatar image="assets/img/awesome-graduation-cap.svg" shape="circle" class="flex"></p-avatar>
          </div>
          <div class="col-9 flex align-content-center flex-wrap">
            <label class="w-full flex align-content-center font-bold">{{attested.AttestatoDesc}}</label>
          </div>
          <div class="col-2 flex align-content-center justify-content-center">
            <label class="flex align-content-center">{{attested.DataConseguimentoStr}}</label>
          </div>
        </div>
        <div class="col-2 lg:col-1 flex align-content-center flex-wrap">
          <div class="col-12 flex align-content-center">
            <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-outlined p-button-danger" (click)="profileAttestedDelete(attested.IdAnagraficaUtenteAttestato)"></button>
          </div>
        </div>
      </li>
    </ul>
    <button pButton pRipple label="Aggiungi attestato o certificazione"
            class="mt-4 col-11 p-button-rounded p-3 btnAddWork font-bold"
            icon="pi pi-plus" iconPos="left" (click)="addAttested()"></button>
  </div>
</div>

<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-2xl">Conoscenze Linguistiche</label>

  <div class="w-full mt-5">
    <ul class="list-none p-0 m-0 w-full">
      <li
        class="flex w-full align-content-center mb-3"
        *ngFor="let language of profileLanguage; index as i">
        <div class="col-10 lg:col-11 flex flex-column md:flex-row align-items-center md:justify-content-between p-0 border-1 sharedListTemplate">
          <div class="col-1 flex">
            <p-avatar image="assets/img/awesome-graduation-cap.svg" shape="circle" class="flex"></p-avatar>
          </div>
          <div class="col-7 flex align-content-center flex-wrap">
            <label class="w-full flex align-content-center font-bold">{{language.LinguaDesc}}</label>
          </div>
          <div class="col-2 flex align-content-center flex-wrap">
            <label class="w-full align-content-center">Parlato </label>
            <label class="w-full flex align-content-center font-bold">{{language.LinguaLivelloParlato}}</label>
          </div>
          <div class="col-2 flex align-content-center flex-wrap">
            <label class="w-full align-content-center">Scritto </label>
            <label class="w-full flex align-content-center font-bold">{{language.LinguaLivelloScritto}}</label>
          </div>
          <div class="col-2 flex align-content-center justify-content-center">
            <label class="flex align-content-center"></label>
          </div>
        </div>
        <div class="col-2 lg:col-1 flex align-content-center flex-wrap">
          <div class="col-12 flex align-content-center">
            <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-outlined p-button-danger" (click)="profileLanguageDelete(language.IdAnagraficaUtenteLingua)"></button>
          </div>
        </div>
      </li>
    </ul>
    <button pButton pRipple label="Aggiungi Lingua"
            class="mt-4 col-11 p-button-rounded p-3 btnAddWork font-bold"
            icon="pi pi-plus" iconPos="left" (click)="addLang()"></button>
  </div>
</div>

<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-2xl">Conoscenze Informatiche</label>
  <div class="w-full mt-5">
    <ul class="list-none p-0 m-0 w-full">
      <li
        class="flex w-full align-content-center mb-3"
        *ngFor="let computerKnowledge of computerKnowledges; index as i">
        <div class="col-12 lg:col-11 flex flex-column md:flex-row align-items-center md:justify-content-between p-0 border-1 sharedListTemplate">
          <div class="col-1 flex">
            <p-avatar image="assets/img/awesome-graduation-cap.svg" shape="circle" class="flex"></p-avatar>
          </div>
          <div class="col-9 flex align-content-center flex-wrap">
            <label class="w-full flex align-content-center font-bold">{{computerKnowledge.Conoscenza}}</label>
          </div>
          <div class="col-1 flex align-content-center justify-content-center">
            <label class="flex align-content-center font-bold"> {{computerKnowledge.ConoscenzaLivello}}</label>
          </div>
          <div class="col-2 flex align-content-center justify-content-center">
            <label class="flex align-content-center"></label>
          </div>
        </div>
        <div class="col-2 lg:col-1 flex align-content-center flex-wrap">
          <div class="col-12 flex align-content-center">
            <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-outlined p-button-danger" (click)="profileConoscenzeDelete(computerKnowledge.IdAnagraficaUtenteConoscenza)"></button>
          </div>
        </div>
      </li>
    </ul>
    <button pButton pRipple label="Aggiungi Conoscenze"
            class="mt-4 col-11 p-button-rounded p-3 btnAddWork font-bold"
            icon="pi pi-plus" iconPos="left" (click)="addInfTec()"></button>
  </div>
</div>

<p-dialog [header]="headerDialogStudy" [(visible)]="showDialogStudy" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"
          [draggable]="false" [resizable]="false">

  <div class="col-12 flex flex-wrap">
    <div class="col-12 flex">
      <label class="labelWidth">Titolo *</label>
      <p-autoComplete
        [(ngModel)]="livelloIstruzione.TitoloStudio"
        [suggestions]="lstTitoloStudio"
        [dropdown]="true"
        name="task"
        field="Descrizione"
        styleClass="w-full"
        class="w-full"
        (completeMethod)="getStudyList($event)"
        (onSelect)="clearSettore()"
        name="task">

        <ng-template let-task pTemplate="item">
          <div class="person-item">
            <div>{{task.Descrizione}}</div>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>
    <div class="col-12 flex" *ngIf="isVisibleSettore">
      <label class="labelWidth">Settore *</label>
      <p-autoComplete
        [(ngModel)]="livelloIstruzione.Settore"
        [suggestions]="lstSettore"
        [dropdown]="true"
        name="task"
        field="Descrizione"
        styleClass="w-full"
        class="w-full"
        (completeMethod)="getSettore($event)"
        (onSelect)="clearSpecializzazione()"
        name="task">
        <ng-template let-task pTemplate="item">
          <div class="person-item">
            <div>{{task.Descrizione}}</div>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>
    <div class="col-12 flex" *ngIf="isVisibleSpecializzazione">
      <label class="labelWidth">Specializzazione </label>
      <p-autoComplete
        [(ngModel)]="livelloIstruzione.Specializzazione"
        [suggestions]="lstSpecializzazione"
        [dropdown]="true"
        name="task"
        field="Descrizione"
        styleClass="w-full"
        class="w-full"
        (completeMethod)="getSpecializzazione($event)"
        name="task">
        <ng-template let-task pTemplate="item">
          <div class="person-item">
            <div>{{task.Descrizione}}</div>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>
    <div class="col-12 flex">
      <label class="labelWidth">Anno</label>
      <!--<p-calendar [(ngModel)]="studySelected.AnnoConseguimento"
                  view="year" dateFormat="yy" inputId="yearpicker"
                  styleClass="w-full" class="w-full" appendTo="body"></p-calendar>-->
      <p-inputNumber [(ngModel)]="studySelected.AnnoConseguimentoStr"
                     class="w-full"
                     styleClass="w-full"
                    [format]="false"></p-inputNumber>
    </div>
    <div class="col-12 flex">
      <label class="labelWidth">In corso</label>
      <p-inputSwitch [(ngModel)]="studySelected.InCorso" class="w-full"></p-inputSwitch>
    </div>
    <div class="col-12 flex">
      <label class="labelWidthVoto">Voto</label>
      <div class="col flex p-0">
        <select class="w-full" pInputText style="appearance: auto"
                [(ngModel)]="studySelected.VotoConseguimento">
          <option *ngFor="let item of markList; let i = index" [ngValue]="item">{{item}}</option>
          <option [ngValue]="null"></option>
        </select>
      </div>
      <div class="col flex p-0">
        <label class="mr-2 ml-2 text-xl">/</label>
        <select class="w-full" pInputText style="appearance: auto"
                [disabled]="studySelected.IdLivelloIstruzione == 1"
                [(ngModel)]="studySelected.VotoMassimo">
          <option [ngValue]="'60'">60</option>
          <option [ngValue]="'60 e lode'">60 e lode</option>
          <option [ngValue]="'100'">100</option>
          <option [ngValue]="'100 e lode'">100 e lode</option>
          <option [ngValue]="'110'">110</option>
          <option [ngValue]="'110 e lode'">110 e lode</option>
          <option [ngValue]="null"></option>
        </select>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="col-12 flex flex-wrap justify-content-end">
      <div class="col-4 xl:col-2 flex justify-content-end">
        <button pButton pRipple label="Annulla" class="mt-4 w-full p-button-rounded p-button-secondary" (click)="closeDialogStudy()"></button>
      </div>
      <div class="col-4 xl:col-2 flex justify-content-end">
        <button pButton pRipple label="Salva" class="mt-4 w-full p-button-rounded" (click)="studyUpsert()"></button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [header]="headerDialogAttested" [(visible)]="showAttestedDialog" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"
          [draggable]="false" [resizable]="false">

  <div class="col-12 flex flex-wrap">
    <div class="col-12 flex">
      <label class="labelWidth">Attestato</label>
      <select class="w-full" pInputText style="appearance: auto"
              [(ngModel)]="attestedSelected.IdAttestato">
        <option *ngFor="let item of attestedTypesList; let i = index" [ngValue]="item.IdAttestato">{{item.AttestatoDesc}}</option>
        <option [ngValue]="null"></option>
      </select>
    </div>
    <div class="col-12 flex">
      <label class="labelWidth">Anno</label>
      <p-calendar [(ngModel)]="attestedSelected.DataConseguimento"
                  view="year"
                  dateFormat="yy"
                  inputId="yearpicker"
                  class="w-full"
                  appendTo="body"></p-calendar>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="col-12 flex flex-wrap justify-content-end">
      <div class="col-4 xl:col-2 flex justify-content-end">
        <button pButton pRipple label="Annulla" class="mt-4 w-full p-button-rounded p-button-secondary" (click)="closeDialogAttested()"></button>
      </div>
      <div class="col-4 xl:col-2 flex justify-content-end">
        <button pButton pRipple label="Salva" class="mt-4 w-full p-button-rounded" (click)="profileAttestedUpsert()"></button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [header]="headerLangDialog" [(visible)]="showLangDialog" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"
          [draggable]="false" [resizable]="false">
  <div class="col-12 flex flex-wrap">
    <div class="col-12 flex">
      <label class="labelWidth">Lingua</label>
      <select class="w-full" pInputText style="appearance: auto"
              [(ngModel)]="selectedLanguage.IdLingua">
        <option *ngFor="let item of languageList; let i = index" [ngValue]="item.IdLingua">{{item.LinguaDesc}}</option>
        <option [ngValue]="null"></option>
      </select>
    </div>
    <div class="col-12 flex">
      <label class="labelWidth">Scritto</label>
      <select class="w-full" pInputText style="appearance: auto"
              [(ngModel)]="selectedLanguage.IdLinguaLivelloScritto">
        <option *ngFor="let item of languageRateList; let i = index" [ngValue]="item.Key">{{item.Value}}</option>
        <option [ngValue]="null"></option>
      </select>
    </div>
    <div class="col-12 flex">
      <label class="labelWidth">Parlato</label>
      <select class="w-full" pInputText style="appearance: auto"
              [(ngModel)]="selectedLanguage.IdLinguaLivelloParlato">
        <option *ngFor="let item of languageRateList; let i = index" [ngValue]="item.Key">{{item.Value}}</option>
        <option [ngValue]="null"></option>
      </select>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="col-12 flex flex-wrap justify-content-end">
      <div class="col-4 xl:col-2 flex justify-content-end">
        <button pButton pRipple label="Annulla" class="mt-4 w-full p-button-rounded p-button-secondary" (click)="closeDialogLang()"></button>
      </div>
      <div class="col-4 xl:col-2 flex justify-content-end">
        <button pButton pRipple label="Salva" class="mt-4 w-full p-button-rounded" (click)="profileLangUpsert()"></button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [header]="headerInformationTecDialog" [(visible)]="showInformationTecDialog" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"
          [draggable]="false" [resizable]="false">
          <div class="col-12 flex flex-wrap">
            <div class="col-12 flex">
              <label class="labelWidth">Conoscenza</label>
              <select class="w-full" pInputText style="appearance: auto"
              [(ngModel)]="selectedConoscenze.IdConoscenza">
                <option *ngFor="let item of conoscenzeLista; let i = index" [ngValue]="item.IdConoscenza">{{item.ConoscenzaDesc}}</option>
                <option [ngValue]="null"></option>
              </select>
            </div>
            <div class="col-12 flex">
              <label class="labelWidth">Livello conoscenza</label>
              <select class="w-full" pInputText style="appearance: auto"
              [(ngModel)]="selectedConoscenze.IdConoscenzaLivello">
                <option *ngFor="let item of conoscenzeRateList; let i = index" [ngValue]="item.Key">{{item.Value}}</option>
                <option [ngValue]="null"></option>
              </select>
            </div>
          </div>
  <ng-template pTemplate="footer">
    <div class="col-12 flex flex-wrap justify-content-end">
      <div class="col-4 xl:col-2 flex justify-content-end">
        <button pButton pRipple label="Annulla" class="mt-4 w-full p-button-rounded p-button-secondary" (click)="closeDialogInfTec()"></button>
      </div>
      <div class="col-4 xl:col-2 flex justify-content-end">
        <button pButton pRipple label="Salva" class="mt-4 w-full p-button-rounded" (click)="computerKnowledgesUpsert()" ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
